var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /Users/v625154/work/perspective/node_modules/isarray/index.js
// module id = 145
// module chunks = 0